/* tslint:disable */
type RelationshipToIssuer =
  'Family Holding' |
  'Foundation' |
  'Management Holding' |
  'Shareholder' |
  'Asset Management Company' |
  'Financial Services Company' |
  'Hedge Fund' |
  'Holding Company' |
  'Investment Company' |
  'Investment Fund' |
  'Investment Management Company' |
  'Private Equity' |
  'Venture Capital' |
  'Affiliated Company' |
  'Endowment Fund' |
  'Parent Company' |
  'Public Company' |
  'Government/Related Entities' |
  'Legal Entity Representation on Board' |
  'Family Holding 10%' |
  'Foundation 10%' |
  'Management Holding 10%' |
  'Shareholder 10%' |
  'Asset Management Company 10%' |
  'Financial Services Company 10%' |
  'Hedge Fund 10%' |
  'Holding Company 10%' |
  'Investment Company 10%' |
  'Investment Fund 10%' |
  'Investment Management Company 10%' |
  'Private Equity 10%' |
  'Venture Capital 10%' |
  'Affiliated Company 10%' |
  'Endowment Fund 10%' |
  'Public Company 10%' |
  'Family Holding Representation on board' |
  'Foundation Representation on board' |
  'Shareholder Representation on board' |
  'Asset Management Company Representation on board' |
  'Financial Services Company Representation on board' |
  'Hedge Fund Representation on board' |
  'Holding Company Representation on board' |
  'Investment Company Representation on board' |
  'Investment Fund Representation on board' |
  'Investment Management Company Representation on board' |
  'Private Equity Representation on board' |
  'Venture Capital Representation on board' |
  'Endowment Fund Representation on board' |
  'Public Company Representation on board' |
  'Government/Related Entities Representation on board' |
  'Board of Directors Holdings' |
  'Family Holding (A)' |
  'Management Board' |
  'Fund Manager (A)' |
  'Investment Manager (A Level)' |
  'Family Office (A)' |
  'Management Holding (B)' |
  'Audit Committee (as group)' |
  'Family Holding (B)' |
  'Investment Advisory Company, BoD' |
  'Investment Bank represented in the Board' |
  'Investment Holding Company, BoD' |
  'Investment Boutique represented in the Board' |
  'Investment Fund, 10% Owner, BoD' |
  'Family Owned Company (C)' |
  'Investment Company represented in the Board' |
  'Board of Commissioners' |
  'Private Equity Company represented in the Board' |
  'Cooperative or Association, BoD, 10% Owner' |
  'Board of Auditors' |
  'Hedge Fund Company represented in the Board' |
  'Bank represented in the Board' |
  'Investment Fund represented in the Board' |
  'Private Equity, 10% Owner, represented in the Board' |
  'REIT, 5% Owner, BoD' |
  'Venture Capital Company, 10% Owner, BoD' |
  'Private Equity Fund, BoD' |
  'Insurance Company, 10% Owner, BoD' |
  'Holding Company represented in the Board' |
  'REIT, 10% Owner, BoD' |
  'Board of Directors Holding' |
  'Venture Capital Company represented in the Board' |
  'Bank, 10% Owner, BoD' |
  'Investment Fund, 5% Owner, BoD' |
  'Private Equity Company, 10% Owner, BoD' |
  'Foundation represented in the Board' |
  'Hedge Fund, 10% Owner, BoD' |
  'Insurance Company, 5% Owner, BoD' |
  'Private Equity Fund, 5% Owner, BoD' |
  'Family Office (C)' |
  'Family Holding (C)' |
  'Shareholders Committee' |
  'Connected Entity' |
  'Investment Management Company, 10% Owner, BoD' |
  'Financial Service Company, BoD' |
  'Alternative Investment Firm represented in the Board' |
  'Private Equity represented in the Board' |
  'Venture Capital Fund represented in the Board' |
  'Investment Company, 10% Owner, BoD' |
  'Investment Management Company, BoD' |
  'REIT' |
  'Holding Company, 10% Owner, BoD' |
  'REIT, 3% Owner' |
  'Asset Management Company, 10% Owner, BoD' |
  'Venture Capital Company, 5% Owner, BoD' |
  'Legal Entity represented in the Board' |
  'Private Equity Fund, 10% Owner, BoD' |
  'Alternative Investment Firm represented in the Board, 10% Owner' |
  'Real Estate Holding Company, 10% Owner, BoD' |
  'REIT, 5% Owner' |
  'Investment Bank, 10% Owner, BoD' |
  'Hedge Fund represented in the Board' |
  'Real Estate Holding Company, BoD' |
  'Asset Management Company represented in the Board' |
  'REIT, 10% Owner' |
  'Insurance Company represented in the Board' |
  'Grantor Retained Annuity Trust' |
  'Influenced corporation' |
  'Other (as group)' |
  'Underwriter' |
  'Trade Union' |
  'Bank' |
  'Related Party' |
  'Employee Trust' |
  'REIT Management Company' |
  'Company General Partner' |
  'Discretionary Trust' |
  'Fund' |
  'Fund Advisory Company' |
  'Nonprofit Organization' |
  'Closed-End Fund, 5%' |
  'Company Investment Manager' |
  'Legal Entity' |
  'Family' |
  'Associated Company' |
  'Charitable Trust' |
  'Charitable Foundation' |
  'Philanthropic Foundation' |
  'Investment Trust' |
  'Family Office/Trust' |
  'Market Maker' |
  'Subsidiary' |
  'Company Asset Manager' |
  'Closed-End Fund' |
  'Account' |
  'Investment Bank, 10% Owner' |
  'Private Equity Company, 5% Owner' |
  'Financial Services Company, 5% Owner' |
  'Real Estate Investment Holding Company, 10% Owner' |
  'Real Estate Investment Holding Company, 5% Owner' |
  'Proprietary Trading Firm' |
  'Private Equity, 5% Owner' |
  'Wealth Management Company' |
  'Private Equity Company, 10% Owner' |
  '10% Holder' |
  'Investor, 5% Owner' |
  'Activist Investor, 3% Owner' |
  'Asset Management Company, 10% Owner' |
  'Bank, 10% Owner' |
  'Special Purpose Entity' |
  '3% Shareholder' |
  'Venture Capital Company, 10% Owner' |
  'Controlling Shareholder' |
  'Hedge Fund, 3% Owner' |
  'Investment Firm, 5% Owner' |
  'Venture Capital Company, 5% Owner' |
  'Investment Trust, 10% Owner' |
  '5% Shareholder' |
  'Family Holding, 10% Owner' |
  'Investment Boutique' |
  'Private Equity Company' |
  'Investment Fund, 3% Owner' |
  'Investment Management Company, 5% Owner' |
  'Public Company, 5% Owner' |
  'Venture Capital Fund, 10% Owner' |
  'Joint ownership' |
  'Investment Bank' |
  'Philanthropic Foundation, 10% Owner' |
  'Venture Capital Company' |
  'Irrevocable Trust, 10% Owner' |
  'Investment Company, 10% Owner' |
  'Private Company' |
  'Alternative Investment Firm, 10% Owner' |
  'Foundation , 10% Owner' |
  'Family Office' |
  'Partner' |
  'Pension Trustee' |
  'Investment Advisory Company, 3%' |
  'Hedge Fund, 10% Owner' |
  'Alternative Investment Firm' |
  'Investor, 3% Owner' |
  'Investment Management Company, 10% Owner' |
  'Shareholder (acting in concert)' |
  'Investment Advisory Company, 10%' |
  'Holding Company, 10% Owner' |
  'Investment Fund, 5% Owner' |
  'Marital Trust, 10% Owner' |
  'Insurance Company, 3% Owner' |
  'Promoter Group (PAC)' |
  'Marital Trust' |
  'Activist Investor' |
  'Financial Services Company, 10% Owner' |
  'Public Company, 10% Owner' |
  'Investment Trust, 5% Owner' |
  'Revocable Trust, 10% Owner' |
  'Investment Firm, 3% Owner' |
  'Member of a Controlling Group' |
  'Investment Boutique, 5% Owner' |
  '13d group' |
  'Investment Trust, 3% Owner' |
  'Investment Boutique, 3% Owner' |
  'Irrevocable Trust' |
  'Investment Holding Company,5% Owner' |
  'Asset Management Company, 5% Owner' |
  'Venture Capital Fund, 3% Owner' |
  'Bank, 5% Owner' |
  'Private Company, 10% Owner' |
  'Pension Fund, 5% Owner' |
  'Living Trust' |
  'Endowment Fund, 10% Owner' |
  'Living Trust, 10% Owner' |
  'Investment Company, 3% Owner' |
  'Insurance Company, 5% Owner' |
  'Insurance Company, 10% Owner' |
  'Real Estate Investment Company, 10% Owner' |
  'Venture Capital Fund' |
  'Special Purpose Entity, 5%' |
  'Investor' |
  'Investment Bank, 5% Owner' |
  'Family Office, 10%' |
  'Wealth Management Company, 10% Owner' |
  'Controlling Group' |
  '10% Owner Group' |
  'Activist Investor represented in the BoD' |
  'Estate' |
  'Limited Partnership' |
  'Wealth Management Company, 5% Owner' |
  'Real Estate Holding Company' |
  'General Partner' |
  'Real Estate Holding Company, 5% Owner' |
  'Investment Management Company, 3% Owner' |
  'Real Estate Holding Company, 10% Owner' |
  'Activist Investor, 5% Owner' |
  'deceased (D)' |
  'Private Equity Company, Main shareholder' |
  'Investment Advisory Company' |
  'Investment Company, 5% Owner' |
  'Indirect shareholder' |
  'Hedge Fund Company, 10% Owner' |
  'Family Holding, 3% Owner' |
  'Real Estate Investment Holding Company' |
  'Private Equity Fund' |
  'Insurance Company' |
  'Affiliated Person' |
  'Endowment Fund, 5%' |
  '10% Shareholder' |
  'Investment Firm' |
  'Investment Boutique, 10% Owner' |
  'Activist Investor, 10% Owner' |
  'Nominee Account (unknown)' |
  'Revocable Trust' |
  'Pension Fund' |
  'Private Equity, 10% Owner' |
  'Investment Holding Company, 10% Owner' |
  'Hedge Fund, 5% Owner' |
  'Investor, 10% Owner' |
  'Managing Partner (H)' |
  'Majority Shareholder (acting in concert)' |
  'Investment Holding Company, 3% Owner' |
  'Former Insider, large Shareholder' |
  'Main shareholder' |
  'Asset Management Company, 3% Owner' |
  'Private Company, 5% Owner' |
  'Pension Fund, 10% Owner' |
  'Private Equity Fund, 5% Owner' |
  'Special Purpose Entity, 10%' |
  'Venture Capital Company, 3% Owner' |
  'Private Equity Fund, 10% Owner' |
  'Substantial Shareholder' |
  'Venture Capital Fund, 5% Owner' |
  'Majority shareholder' |
  'Holding Company, 5% Owner' |
  'Investment Advisory Company, 5%' |
  'Alternative Investment Firm, 5% Owner' |
  'Family Holding, 5% Owner' |
  'Investment Firm, 10% Owner' |
  'Investment Fund, 10% Owner' |
  'Investment Holding Company' |
  'Family Office, 5%' |
  'Sponsor (Entity)' |
  '10% Owner' |
  'family controlled corporation' |
  'Depositary Bank' |
  'Nominated Advisor' |
  'Lending agent' |
  'Exchange Traded Fund' |
  'Broker' |
  'Custodian corporation' |
  'Nominated Advisor and Broker' |
  'Custodian' |
  'National Retirement System' |
  'Government/Municipality' |
  'Government Statutory Body' |
  'Government-linked company' |
  'Political Party' |
  'Public Pension Fund' |
  'International Finance Institution' |
  'Deposit Insurance, 10% Owner' |
  'International Finance Institute' |
  'State-owned company' |
  'Government Sovereign Fund Manager' |
  'Government Agency' |
  'State Teachers Retirement System' |
  'Sovereign Wealth Fund' |
  'Government owned company' |
  'National Pension Plan' |
  'Public Investment Fund' |
  'Provinced-Owned Entity' |
  'Central Bank' |
  'Supranational Bank' |
  'Government Pension Fund Manager' |
  'Public Bank' |
  'Public Investment Bank' |
  'International Governmental Organisation' |
  'Multilateral Development Bank';
module RelationshipToIssuer {
  export const FAMILY_HOLDING: RelationshipToIssuer = 'Family Holding';
  export const FOUNDATION: RelationshipToIssuer = 'Foundation';
  export const MANAGEMENT_HOLDING: RelationshipToIssuer = 'Management Holding';
  export const SHAREHOLDER: RelationshipToIssuer = 'Shareholder';
  export const ASSET_MANAGEMENT_COMPANY: RelationshipToIssuer = 'Asset Management Company';
  export const FINANCIAL_SERVICES_COMPANY: RelationshipToIssuer = 'Financial Services Company';
  export const HEDGE_FUND: RelationshipToIssuer = 'Hedge Fund';
  export const HOLDING_COMPANY: RelationshipToIssuer = 'Holding Company';
  export const INVESTMENT_COMPANY: RelationshipToIssuer = 'Investment Company';
  export const INVESTMENT_FUND: RelationshipToIssuer = 'Investment Fund';
  export const INVESTMENT_MANAGEMENT_COMPANY: RelationshipToIssuer = 'Investment Management Company';
  export const PRIVATE_EQUITY: RelationshipToIssuer = 'Private Equity';
  export const VENTURE_CAPITAL: RelationshipToIssuer = 'Venture Capital';
  export const AFFILIATED_COMPANY: RelationshipToIssuer = 'Affiliated Company';
  export const ENDOWMENT_FUND: RelationshipToIssuer = 'Endowment Fund';
  export const PARENT_COMPANY: RelationshipToIssuer = 'Parent Company';
  export const PUBLIC_COMPANY: RelationshipToIssuer = 'Public Company';
  export const GOVERNMENT_RELATED_ENTITIES: RelationshipToIssuer = 'Government/Related Entities';
  export const LEGAL_ENTITY_REPRESENTATION_ON_BOARD: RelationshipToIssuer = 'Legal Entity Representation on Board';
  export const FAMILY_HOLDING_10_: RelationshipToIssuer = 'Family Holding 10%';
  export const FOUNDATION_10_: RelationshipToIssuer = 'Foundation 10%';
  export const MANAGEMENT_HOLDING_10_: RelationshipToIssuer = 'Management Holding 10%';
  export const SHAREHOLDER_10_: RelationshipToIssuer = 'Shareholder 10%';
  export const ASSET_MANAGEMENT_COMPANY_10_: RelationshipToIssuer = 'Asset Management Company 10%';
  export const FINANCIAL_SERVICES_COMPANY_10_: RelationshipToIssuer = 'Financial Services Company 10%';
  export const HEDGE_FUND_10_: RelationshipToIssuer = 'Hedge Fund 10%';
  export const HOLDING_COMPANY_10_: RelationshipToIssuer = 'Holding Company 10%';
  export const INVESTMENT_COMPANY_10_: RelationshipToIssuer = 'Investment Company 10%';
  export const INVESTMENT_FUND_10_: RelationshipToIssuer = 'Investment Fund 10%';
  export const INVESTMENT_MANAGEMENT_COMPANY_10_: RelationshipToIssuer = 'Investment Management Company 10%';
  export const PRIVATE_EQUITY_10_: RelationshipToIssuer = 'Private Equity 10%';
  export const VENTURE_CAPITAL_10_: RelationshipToIssuer = 'Venture Capital 10%';
  export const AFFILIATED_COMPANY_10_: RelationshipToIssuer = 'Affiliated Company 10%';
  export const ENDOWMENT_FUND_10_: RelationshipToIssuer = 'Endowment Fund 10%';
  export const PUBLIC_COMPANY_10_: RelationshipToIssuer = 'Public Company 10%';
  export const FAMILY_HOLDING_REPRESENTATION_ON_BOARD: RelationshipToIssuer = 'Family Holding Representation on board';
  export const FOUNDATION_REPRESENTATION_ON_BOARD: RelationshipToIssuer = 'Foundation Representation on board';
  export const SHAREHOLDER_REPRESENTATION_ON_BOARD: RelationshipToIssuer = 'Shareholder Representation on board';
  export const ASSET_MANAGEMENT_COMPANY_REPRESENTATION_ON_BOARD: RelationshipToIssuer = 'Asset Management Company Representation on board';
  export const FINANCIAL_SERVICES_COMPANY_REPRESENTATION_ON_BOARD: RelationshipToIssuer = 'Financial Services Company Representation on board';
  export const HEDGE_FUND_REPRESENTATION_ON_BOARD: RelationshipToIssuer = 'Hedge Fund Representation on board';
  export const HOLDING_COMPANY_REPRESENTATION_ON_BOARD: RelationshipToIssuer = 'Holding Company Representation on board';
  export const INVESTMENT_COMPANY_REPRESENTATION_ON_BOARD: RelationshipToIssuer = 'Investment Company Representation on board';
  export const INVESTMENT_FUND_REPRESENTATION_ON_BOARD: RelationshipToIssuer = 'Investment Fund Representation on board';
  export const INVESTMENT_MANAGEMENT_COMPANY_REPRESENTATION_ON_BOARD: RelationshipToIssuer = 'Investment Management Company Representation on board';
  export const PRIVATE_EQUITY_REPRESENTATION_ON_BOARD: RelationshipToIssuer = 'Private Equity Representation on board';
  export const VENTURE_CAPITAL_REPRESENTATION_ON_BOARD: RelationshipToIssuer = 'Venture Capital Representation on board';
  export const ENDOWMENT_FUND_REPRESENTATION_ON_BOARD: RelationshipToIssuer = 'Endowment Fund Representation on board';
  export const PUBLIC_COMPANY_REPRESENTATION_ON_BOARD: RelationshipToIssuer = 'Public Company Representation on board';
  export const GOVERNMENT_RELATED_ENTITIES_REPRESENTATION_ON_BOARD: RelationshipToIssuer = 'Government/Related Entities Representation on board';
  export const BOARD_OF_DIRECTORS_HOLDINGS: RelationshipToIssuer = 'Board of Directors Holdings';
  export const FAMILY_HOLDING_A_: RelationshipToIssuer = 'Family Holding (A)';
  export const MANAGEMENT_BOARD: RelationshipToIssuer = 'Management Board';
  export const FUND_MANAGER_A_: RelationshipToIssuer = 'Fund Manager (A)';
  export const INVESTMENT_MANAGER_A_LEVEL_: RelationshipToIssuer = 'Investment Manager (A Level)';
  export const FAMILY_OFFICE_A_: RelationshipToIssuer = 'Family Office (A)';
  export const MANAGEMENT_HOLDING_B_: RelationshipToIssuer = 'Management Holding (B)';
  export const AUDIT_COMMITTEE_AS_GROUP_: RelationshipToIssuer = 'Audit Committee (as group)';
  export const FAMILY_HOLDING_B_: RelationshipToIssuer = 'Family Holding (B)';
  export const INVESTMENT_ADVISORY_COMPANY_BO_D: RelationshipToIssuer = 'Investment Advisory Company, BoD';
  export const INVESTMENT_BANK_REPRESENTED_IN_THE_BOARD: RelationshipToIssuer = 'Investment Bank represented in the Board';
  export const INVESTMENT_HOLDING_COMPANY_BO_D: RelationshipToIssuer = 'Investment Holding Company, BoD';
  export const INVESTMENT_BOUTIQUE_REPRESENTED_IN_THE_BOARD: RelationshipToIssuer = 'Investment Boutique represented in the Board';
  export const INVESTMENT_FUND_10_OWNER_BO_D: RelationshipToIssuer = 'Investment Fund, 10% Owner, BoD';
  export const FAMILY_OWNED_COMPANY_C_: RelationshipToIssuer = 'Family Owned Company (C)';
  export const INVESTMENT_COMPANY_REPRESENTED_IN_THE_BOARD: RelationshipToIssuer = 'Investment Company represented in the Board';
  export const BOARD_OF_COMMISSIONERS: RelationshipToIssuer = 'Board of Commissioners';
  export const PRIVATE_EQUITY_COMPANY_REPRESENTED_IN_THE_BOARD: RelationshipToIssuer = 'Private Equity Company represented in the Board';
  export const COOPERATIVE_OR_ASSOCIATION_BO_D_10_OWNER: RelationshipToIssuer = 'Cooperative or Association, BoD, 10% Owner';
  export const BOARD_OF_AUDITORS: RelationshipToIssuer = 'Board of Auditors';
  export const HEDGE_FUND_COMPANY_REPRESENTED_IN_THE_BOARD: RelationshipToIssuer = 'Hedge Fund Company represented in the Board';
  export const BANK_REPRESENTED_IN_THE_BOARD: RelationshipToIssuer = 'Bank represented in the Board';
  export const INVESTMENT_FUND_REPRESENTED_IN_THE_BOARD: RelationshipToIssuer = 'Investment Fund represented in the Board';
  export const PRIVATE_EQUITY_10_OWNER_REPRESENTED_IN_THE_BOARD: RelationshipToIssuer = 'Private Equity, 10% Owner, represented in the Board';
  export const REIT_5_OWNER_BO_D: RelationshipToIssuer = 'REIT, 5% Owner, BoD';
  export const VENTURE_CAPITAL_COMPANY_10_OWNER_BO_D: RelationshipToIssuer = 'Venture Capital Company, 10% Owner, BoD';
  export const PRIVATE_EQUITY_FUND_BO_D: RelationshipToIssuer = 'Private Equity Fund, BoD';
  export const INSURANCE_COMPANY_10_OWNER_BO_D: RelationshipToIssuer = 'Insurance Company, 10% Owner, BoD';
  export const HOLDING_COMPANY_REPRESENTED_IN_THE_BOARD: RelationshipToIssuer = 'Holding Company represented in the Board';
  export const REIT_10_OWNER_BO_D: RelationshipToIssuer = 'REIT, 10% Owner, BoD';
  export const BOARD_OF_DIRECTORS_HOLDING: RelationshipToIssuer = 'Board of Directors Holding';
  export const VENTURE_CAPITAL_COMPANY_REPRESENTED_IN_THE_BOARD: RelationshipToIssuer = 'Venture Capital Company represented in the Board';
  export const BANK_10_OWNER_BO_D: RelationshipToIssuer = 'Bank, 10% Owner, BoD';
  export const INVESTMENT_FUND_5_OWNER_BO_D: RelationshipToIssuer = 'Investment Fund, 5% Owner, BoD';
  export const PRIVATE_EQUITY_COMPANY_10_OWNER_BO_D: RelationshipToIssuer = 'Private Equity Company, 10% Owner, BoD';
  export const FOUNDATION_REPRESENTED_IN_THE_BOARD: RelationshipToIssuer = 'Foundation represented in the Board';
  export const HEDGE_FUND_10_OWNER_BO_D: RelationshipToIssuer = 'Hedge Fund, 10% Owner, BoD';
  export const INSURANCE_COMPANY_5_OWNER_BO_D: RelationshipToIssuer = 'Insurance Company, 5% Owner, BoD';
  export const PRIVATE_EQUITY_FUND_5_OWNER_BO_D: RelationshipToIssuer = 'Private Equity Fund, 5% Owner, BoD';
  export const FAMILY_OFFICE_C_: RelationshipToIssuer = 'Family Office (C)';
  export const FAMILY_HOLDING_C_: RelationshipToIssuer = 'Family Holding (C)';
  export const SHAREHOLDERS_COMMITTEE: RelationshipToIssuer = 'Shareholders Committee';
  export const CONNECTED_ENTITY: RelationshipToIssuer = 'Connected Entity';
  export const INVESTMENT_MANAGEMENT_COMPANY_10_OWNER_BO_D: RelationshipToIssuer = 'Investment Management Company, 10% Owner, BoD';
  export const FINANCIAL_SERVICE_COMPANY_BO_D: RelationshipToIssuer = 'Financial Service Company, BoD';
  export const ALTERNATIVE_INVESTMENT_FIRM_REPRESENTED_IN_THE_BOARD: RelationshipToIssuer = 'Alternative Investment Firm represented in the Board';
  export const PRIVATE_EQUITY_REPRESENTED_IN_THE_BOARD: RelationshipToIssuer = 'Private Equity represented in the Board';
  export const VENTURE_CAPITAL_FUND_REPRESENTED_IN_THE_BOARD: RelationshipToIssuer = 'Venture Capital Fund represented in the Board';
  export const INVESTMENT_COMPANY_10_OWNER_BO_D: RelationshipToIssuer = 'Investment Company, 10% Owner, BoD';
  export const INVESTMENT_MANAGEMENT_COMPANY_BO_D: RelationshipToIssuer = 'Investment Management Company, BoD';
  export const REIT: RelationshipToIssuer = 'REIT';
  export const HOLDING_COMPANY_10_OWNER_BO_D: RelationshipToIssuer = 'Holding Company, 10% Owner, BoD';
  export const REIT_3_OWNER: RelationshipToIssuer = 'REIT, 3% Owner';
  export const ASSET_MANAGEMENT_COMPANY_10_OWNER_BO_D: RelationshipToIssuer = 'Asset Management Company, 10% Owner, BoD';
  export const VENTURE_CAPITAL_COMPANY_5_OWNER_BO_D: RelationshipToIssuer = 'Venture Capital Company, 5% Owner, BoD';
  export const LEGAL_ENTITY_REPRESENTED_IN_THE_BOARD: RelationshipToIssuer = 'Legal Entity represented in the Board';
  export const PRIVATE_EQUITY_FUND_10_OWNER_BO_D: RelationshipToIssuer = 'Private Equity Fund, 10% Owner, BoD';
  export const ALTERNATIVE_INVESTMENT_FIRM_REPRESENTED_IN_THE_BOARD_10_OWNER: RelationshipToIssuer = 'Alternative Investment Firm represented in the Board, 10% Owner';
  export const REAL_ESTATE_HOLDING_COMPANY_10_OWNER_BO_D: RelationshipToIssuer = 'Real Estate Holding Company, 10% Owner, BoD';
  export const REIT_5_OWNER: RelationshipToIssuer = 'REIT, 5% Owner';
  export const INVESTMENT_BANK_10_OWNER_BO_D: RelationshipToIssuer = 'Investment Bank, 10% Owner, BoD';
  export const HEDGE_FUND_REPRESENTED_IN_THE_BOARD: RelationshipToIssuer = 'Hedge Fund represented in the Board';
  export const REAL_ESTATE_HOLDING_COMPANY_BO_D: RelationshipToIssuer = 'Real Estate Holding Company, BoD';
  export const ASSET_MANAGEMENT_COMPANY_REPRESENTED_IN_THE_BOARD: RelationshipToIssuer = 'Asset Management Company represented in the Board';
  export const REIT_10_OWNER: RelationshipToIssuer = 'REIT, 10% Owner';
  export const INSURANCE_COMPANY_REPRESENTED_IN_THE_BOARD: RelationshipToIssuer = 'Insurance Company represented in the Board';
  export const GRANTOR_RETAINED_ANNUITY_TRUST: RelationshipToIssuer = 'Grantor Retained Annuity Trust';
  export const INFLUENCED_CORPORATION: RelationshipToIssuer = 'Influenced corporation';
  export const OTHER_AS_GROUP_: RelationshipToIssuer = 'Other (as group)';
  export const UNDERWRITER: RelationshipToIssuer = 'Underwriter';
  export const TRADE_UNION: RelationshipToIssuer = 'Trade Union';
  export const BANK: RelationshipToIssuer = 'Bank';
  export const RELATED_PARTY: RelationshipToIssuer = 'Related Party';
  export const EMPLOYEE_TRUST: RelationshipToIssuer = 'Employee Trust';
  export const REIT_MANAGEMENT_COMPANY: RelationshipToIssuer = 'REIT Management Company';
  export const COMPANY_GENERAL_PARTNER: RelationshipToIssuer = 'Company General Partner';
  export const DISCRETIONARY_TRUST: RelationshipToIssuer = 'Discretionary Trust';
  export const FUND: RelationshipToIssuer = 'Fund';
  export const FUND_ADVISORY_COMPANY: RelationshipToIssuer = 'Fund Advisory Company';
  export const NONPROFIT_ORGANIZATION: RelationshipToIssuer = 'Nonprofit Organization';
  export const CLOSED_END_FUND_5_: RelationshipToIssuer = 'Closed-End Fund, 5%';
  export const COMPANY_INVESTMENT_MANAGER: RelationshipToIssuer = 'Company Investment Manager';
  export const LEGAL_ENTITY: RelationshipToIssuer = 'Legal Entity';
  export const FAMILY: RelationshipToIssuer = 'Family';
  export const ASSOCIATED_COMPANY: RelationshipToIssuer = 'Associated Company';
  export const CHARITABLE_TRUST: RelationshipToIssuer = 'Charitable Trust';
  export const CHARITABLE_FOUNDATION: RelationshipToIssuer = 'Charitable Foundation';
  export const PHILANTHROPIC_FOUNDATION: RelationshipToIssuer = 'Philanthropic Foundation';
  export const INVESTMENT_TRUST: RelationshipToIssuer = 'Investment Trust';
  export const FAMILY_OFFICE_TRUST: RelationshipToIssuer = 'Family Office/Trust';
  export const MARKET_MAKER: RelationshipToIssuer = 'Market Maker';
  export const SUBSIDIARY: RelationshipToIssuer = 'Subsidiary';
  export const COMPANY_ASSET_MANAGER: RelationshipToIssuer = 'Company Asset Manager';
  export const CLOSED_END_FUND: RelationshipToIssuer = 'Closed-End Fund';
  export const ACCOUNT: RelationshipToIssuer = 'Account';
  export const INVESTMENT_BANK_10_OWNER: RelationshipToIssuer = 'Investment Bank, 10% Owner';
  export const PRIVATE_EQUITY_COMPANY_5_OWNER: RelationshipToIssuer = 'Private Equity Company, 5% Owner';
  export const FINANCIAL_SERVICES_COMPANY_5_OWNER: RelationshipToIssuer = 'Financial Services Company, 5% Owner';
  export const REAL_ESTATE_INVESTMENT_HOLDING_COMPANY_10_OWNER: RelationshipToIssuer = 'Real Estate Investment Holding Company, 10% Owner';
  export const REAL_ESTATE_INVESTMENT_HOLDING_COMPANY_5_OWNER: RelationshipToIssuer = 'Real Estate Investment Holding Company, 5% Owner';
  export const PROPRIETARY_TRADING_FIRM: RelationshipToIssuer = 'Proprietary Trading Firm';
  export const PRIVATE_EQUITY_5_OWNER: RelationshipToIssuer = 'Private Equity, 5% Owner';
  export const WEALTH_MANAGEMENT_COMPANY: RelationshipToIssuer = 'Wealth Management Company';
  export const PRIVATE_EQUITY_COMPANY_10_OWNER: RelationshipToIssuer = 'Private Equity Company, 10% Owner';
  export const _10_HOLDER: RelationshipToIssuer = '10% Holder';
  export const INVESTOR_5_OWNER: RelationshipToIssuer = 'Investor, 5% Owner';
  export const ACTIVIST_INVESTOR_3_OWNER: RelationshipToIssuer = 'Activist Investor, 3% Owner';
  export const ASSET_MANAGEMENT_COMPANY_10_OWNER: RelationshipToIssuer = 'Asset Management Company, 10% Owner';
  export const BANK_10_OWNER: RelationshipToIssuer = 'Bank, 10% Owner';
  export const SPECIAL_PURPOSE_ENTITY: RelationshipToIssuer = 'Special Purpose Entity';
  export const _3_SHAREHOLDER: RelationshipToIssuer = '3% Shareholder';
  export const VENTURE_CAPITAL_COMPANY_10_OWNER: RelationshipToIssuer = 'Venture Capital Company, 10% Owner';
  export const CONTROLLING_SHAREHOLDER: RelationshipToIssuer = 'Controlling Shareholder';
  export const HEDGE_FUND_3_OWNER: RelationshipToIssuer = 'Hedge Fund, 3% Owner';
  export const INVESTMENT_FIRM_5_OWNER: RelationshipToIssuer = 'Investment Firm, 5% Owner';
  export const VENTURE_CAPITAL_COMPANY_5_OWNER: RelationshipToIssuer = 'Venture Capital Company, 5% Owner';
  export const INVESTMENT_TRUST_10_OWNER: RelationshipToIssuer = 'Investment Trust, 10% Owner';
  export const _5_SHAREHOLDER: RelationshipToIssuer = '5% Shareholder';
  export const FAMILY_HOLDING_10_OWNER: RelationshipToIssuer = 'Family Holding, 10% Owner';
  export const INVESTMENT_BOUTIQUE: RelationshipToIssuer = 'Investment Boutique';
  export const PRIVATE_EQUITY_COMPANY: RelationshipToIssuer = 'Private Equity Company';
  export const INVESTMENT_FUND_3_OWNER: RelationshipToIssuer = 'Investment Fund, 3% Owner';
  export const INVESTMENT_MANAGEMENT_COMPANY_5_OWNER: RelationshipToIssuer = 'Investment Management Company, 5% Owner';
  export const PUBLIC_COMPANY_5_OWNER: RelationshipToIssuer = 'Public Company, 5% Owner';
  export const VENTURE_CAPITAL_FUND_10_OWNER: RelationshipToIssuer = 'Venture Capital Fund, 10% Owner';
  export const JOINT_OWNERSHIP: RelationshipToIssuer = 'Joint ownership';
  export const INVESTMENT_BANK: RelationshipToIssuer = 'Investment Bank';
  export const PHILANTHROPIC_FOUNDATION_10_OWNER: RelationshipToIssuer = 'Philanthropic Foundation, 10% Owner';
  export const VENTURE_CAPITAL_COMPANY: RelationshipToIssuer = 'Venture Capital Company';
  export const IRREVOCABLE_TRUST_10_OWNER: RelationshipToIssuer = 'Irrevocable Trust, 10% Owner';
  export const INVESTMENT_COMPANY_10_OWNER: RelationshipToIssuer = 'Investment Company, 10% Owner';
  export const PRIVATE_COMPANY: RelationshipToIssuer = 'Private Company';
  export const ALTERNATIVE_INVESTMENT_FIRM_10_OWNER: RelationshipToIssuer = 'Alternative Investment Firm, 10% Owner';
  export const FOUNDATION_10_OWNER: RelationshipToIssuer = 'Foundation , 10% Owner';
  export const FAMILY_OFFICE: RelationshipToIssuer = 'Family Office';
  export const PARTNER: RelationshipToIssuer = 'Partner';
  export const PENSION_TRUSTEE: RelationshipToIssuer = 'Pension Trustee';
  export const INVESTMENT_ADVISORY_COMPANY_3_: RelationshipToIssuer = 'Investment Advisory Company, 3%';
  export const HEDGE_FUND_10_OWNER: RelationshipToIssuer = 'Hedge Fund, 10% Owner';
  export const ALTERNATIVE_INVESTMENT_FIRM: RelationshipToIssuer = 'Alternative Investment Firm';
  export const INVESTOR_3_OWNER: RelationshipToIssuer = 'Investor, 3% Owner';
  export const INVESTMENT_MANAGEMENT_COMPANY_10_OWNER: RelationshipToIssuer = 'Investment Management Company, 10% Owner';
  export const SHAREHOLDER_ACTING_IN_CONCERT_: RelationshipToIssuer = 'Shareholder (acting in concert)';
  export const INVESTMENT_ADVISORY_COMPANY_10_: RelationshipToIssuer = 'Investment Advisory Company, 10%';
  export const HOLDING_COMPANY_10_OWNER: RelationshipToIssuer = 'Holding Company, 10% Owner';
  export const INVESTMENT_FUND_5_OWNER: RelationshipToIssuer = 'Investment Fund, 5% Owner';
  export const MARITAL_TRUST_10_OWNER: RelationshipToIssuer = 'Marital Trust, 10% Owner';
  export const INSURANCE_COMPANY_3_OWNER: RelationshipToIssuer = 'Insurance Company, 3% Owner';
  export const PROMOTER_GROUP_PAC_: RelationshipToIssuer = 'Promoter Group (PAC)';
  export const MARITAL_TRUST: RelationshipToIssuer = 'Marital Trust';
  export const ACTIVIST_INVESTOR: RelationshipToIssuer = 'Activist Investor';
  export const FINANCIAL_SERVICES_COMPANY_10_OWNER: RelationshipToIssuer = 'Financial Services Company, 10% Owner';
  export const PUBLIC_COMPANY_10_OWNER: RelationshipToIssuer = 'Public Company, 10% Owner';
  export const INVESTMENT_TRUST_5_OWNER: RelationshipToIssuer = 'Investment Trust, 5% Owner';
  export const REVOCABLE_TRUST_10_OWNER: RelationshipToIssuer = 'Revocable Trust, 10% Owner';
  export const INVESTMENT_FIRM_3_OWNER: RelationshipToIssuer = 'Investment Firm, 3% Owner';
  export const MEMBER_OF_A_CONTROLLING_GROUP: RelationshipToIssuer = 'Member of a Controlling Group';
  export const INVESTMENT_BOUTIQUE_5_OWNER: RelationshipToIssuer = 'Investment Boutique, 5% Owner';
  export const _13D_GROUP: RelationshipToIssuer = '13d group';
  export const INVESTMENT_TRUST_3_OWNER: RelationshipToIssuer = 'Investment Trust, 3% Owner';
  export const INVESTMENT_BOUTIQUE_3_OWNER: RelationshipToIssuer = 'Investment Boutique, 3% Owner';
  export const IRREVOCABLE_TRUST: RelationshipToIssuer = 'Irrevocable Trust';
  export const INVESTMENT_HOLDING_COMPANY_5_OWNER: RelationshipToIssuer = 'Investment Holding Company,5% Owner';
  export const ASSET_MANAGEMENT_COMPANY_5_OWNER: RelationshipToIssuer = 'Asset Management Company, 5% Owner';
  export const VENTURE_CAPITAL_FUND_3_OWNER: RelationshipToIssuer = 'Venture Capital Fund, 3% Owner';
  export const BANK_5_OWNER: RelationshipToIssuer = 'Bank, 5% Owner';
  export const PRIVATE_COMPANY_10_OWNER: RelationshipToIssuer = 'Private Company, 10% Owner';
  export const PENSION_FUND_5_OWNER: RelationshipToIssuer = 'Pension Fund, 5% Owner';
  export const LIVING_TRUST: RelationshipToIssuer = 'Living Trust';
  export const ENDOWMENT_FUND_10_OWNER: RelationshipToIssuer = 'Endowment Fund, 10% Owner';
  export const LIVING_TRUST_10_OWNER: RelationshipToIssuer = 'Living Trust, 10% Owner';
  export const INVESTMENT_COMPANY_3_OWNER: RelationshipToIssuer = 'Investment Company, 3% Owner';
  export const INSURANCE_COMPANY_5_OWNER: RelationshipToIssuer = 'Insurance Company, 5% Owner';
  export const INSURANCE_COMPANY_10_OWNER: RelationshipToIssuer = 'Insurance Company, 10% Owner';
  export const REAL_ESTATE_INVESTMENT_COMPANY_10_OWNER: RelationshipToIssuer = 'Real Estate Investment Company, 10% Owner';
  export const VENTURE_CAPITAL_FUND: RelationshipToIssuer = 'Venture Capital Fund';
  export const SPECIAL_PURPOSE_ENTITY_5_: RelationshipToIssuer = 'Special Purpose Entity, 5%';
  export const INVESTOR: RelationshipToIssuer = 'Investor';
  export const INVESTMENT_BANK_5_OWNER: RelationshipToIssuer = 'Investment Bank, 5% Owner';
  export const FAMILY_OFFICE_10_: RelationshipToIssuer = 'Family Office, 10%';
  export const WEALTH_MANAGEMENT_COMPANY_10_OWNER: RelationshipToIssuer = 'Wealth Management Company, 10% Owner';
  export const CONTROLLING_GROUP: RelationshipToIssuer = 'Controlling Group';
  export const _10_OWNER_GROUP: RelationshipToIssuer = '10% Owner Group';
  export const ACTIVIST_INVESTOR_REPRESENTED_IN_THE_BO_D: RelationshipToIssuer = 'Activist Investor represented in the BoD';
  export const ESTATE: RelationshipToIssuer = 'Estate';
  export const LIMITED_PARTNERSHIP: RelationshipToIssuer = 'Limited Partnership';
  export const WEALTH_MANAGEMENT_COMPANY_5_OWNER: RelationshipToIssuer = 'Wealth Management Company, 5% Owner';
  export const REAL_ESTATE_HOLDING_COMPANY: RelationshipToIssuer = 'Real Estate Holding Company';
  export const GENERAL_PARTNER: RelationshipToIssuer = 'General Partner';
  export const REAL_ESTATE_HOLDING_COMPANY_5_OWNER: RelationshipToIssuer = 'Real Estate Holding Company, 5% Owner';
  export const INVESTMENT_MANAGEMENT_COMPANY_3_OWNER: RelationshipToIssuer = 'Investment Management Company, 3% Owner';
  export const REAL_ESTATE_HOLDING_COMPANY_10_OWNER: RelationshipToIssuer = 'Real Estate Holding Company, 10% Owner';
  export const ACTIVIST_INVESTOR_5_OWNER: RelationshipToIssuer = 'Activist Investor, 5% Owner';
  export const DECEASED_D_: RelationshipToIssuer = 'deceased (D)';
  export const PRIVATE_EQUITY_COMPANY_MAIN_SHAREHOLDER: RelationshipToIssuer = 'Private Equity Company, Main shareholder';
  export const INVESTMENT_ADVISORY_COMPANY: RelationshipToIssuer = 'Investment Advisory Company';
  export const INVESTMENT_COMPANY_5_OWNER: RelationshipToIssuer = 'Investment Company, 5% Owner';
  export const INDIRECT_SHAREHOLDER: RelationshipToIssuer = 'Indirect shareholder';
  export const HEDGE_FUND_COMPANY_10_OWNER: RelationshipToIssuer = 'Hedge Fund Company, 10% Owner';
  export const FAMILY_HOLDING_3_OWNER: RelationshipToIssuer = 'Family Holding, 3% Owner';
  export const REAL_ESTATE_INVESTMENT_HOLDING_COMPANY: RelationshipToIssuer = 'Real Estate Investment Holding Company';
  export const PRIVATE_EQUITY_FUND: RelationshipToIssuer = 'Private Equity Fund';
  export const INSURANCE_COMPANY: RelationshipToIssuer = 'Insurance Company';
  export const AFFILIATED_PERSON: RelationshipToIssuer = 'Affiliated Person';
  export const ENDOWMENT_FUND_5_: RelationshipToIssuer = 'Endowment Fund, 5%';
  export const _10_SHAREHOLDER: RelationshipToIssuer = '10% Shareholder';
  export const INVESTMENT_FIRM: RelationshipToIssuer = 'Investment Firm';
  export const INVESTMENT_BOUTIQUE_10_OWNER: RelationshipToIssuer = 'Investment Boutique, 10% Owner';
  export const ACTIVIST_INVESTOR_10_OWNER: RelationshipToIssuer = 'Activist Investor, 10% Owner';
  export const NOMINEE_ACCOUNT_UNKNOWN_: RelationshipToIssuer = 'Nominee Account (unknown)';
  export const REVOCABLE_TRUST: RelationshipToIssuer = 'Revocable Trust';
  export const PENSION_FUND: RelationshipToIssuer = 'Pension Fund';
  export const PRIVATE_EQUITY_10_OWNER: RelationshipToIssuer = 'Private Equity, 10% Owner';
  export const INVESTMENT_HOLDING_COMPANY_10_OWNER: RelationshipToIssuer = 'Investment Holding Company, 10% Owner';
  export const HEDGE_FUND_5_OWNER: RelationshipToIssuer = 'Hedge Fund, 5% Owner';
  export const INVESTOR_10_OWNER: RelationshipToIssuer = 'Investor, 10% Owner';
  export const MANAGING_PARTNER_H_: RelationshipToIssuer = 'Managing Partner (H)';
  export const MAJORITY_SHAREHOLDER_ACTING_IN_CONCERT_: RelationshipToIssuer = 'Majority Shareholder (acting in concert)';
  export const INVESTMENT_HOLDING_COMPANY_3_OWNER: RelationshipToIssuer = 'Investment Holding Company, 3% Owner';
  export const FORMER_INSIDER_LARGE_SHAREHOLDER: RelationshipToIssuer = 'Former Insider, large Shareholder';
  export const MAIN_SHAREHOLDER: RelationshipToIssuer = 'Main shareholder';
  export const ASSET_MANAGEMENT_COMPANY_3_OWNER: RelationshipToIssuer = 'Asset Management Company, 3% Owner';
  export const PRIVATE_COMPANY_5_OWNER: RelationshipToIssuer = 'Private Company, 5% Owner';
  export const PENSION_FUND_10_OWNER: RelationshipToIssuer = 'Pension Fund, 10% Owner';
  export const PRIVATE_EQUITY_FUND_5_OWNER: RelationshipToIssuer = 'Private Equity Fund, 5% Owner';
  export const SPECIAL_PURPOSE_ENTITY_10_: RelationshipToIssuer = 'Special Purpose Entity, 10%';
  export const VENTURE_CAPITAL_COMPANY_3_OWNER: RelationshipToIssuer = 'Venture Capital Company, 3% Owner';
  export const PRIVATE_EQUITY_FUND_10_OWNER: RelationshipToIssuer = 'Private Equity Fund, 10% Owner';
  export const SUBSTANTIAL_SHAREHOLDER: RelationshipToIssuer = 'Substantial Shareholder';
  export const VENTURE_CAPITAL_FUND_5_OWNER: RelationshipToIssuer = 'Venture Capital Fund, 5% Owner';
  export const MAJORITY_SHAREHOLDER: RelationshipToIssuer = 'Majority shareholder';
  export const HOLDING_COMPANY_5_OWNER: RelationshipToIssuer = 'Holding Company, 5% Owner';
  export const INVESTMENT_ADVISORY_COMPANY_5_: RelationshipToIssuer = 'Investment Advisory Company, 5%';
  export const ALTERNATIVE_INVESTMENT_FIRM_5_OWNER: RelationshipToIssuer = 'Alternative Investment Firm, 5% Owner';
  export const FAMILY_HOLDING_5_OWNER: RelationshipToIssuer = 'Family Holding, 5% Owner';
  export const INVESTMENT_FIRM_10_OWNER: RelationshipToIssuer = 'Investment Firm, 10% Owner';
  export const INVESTMENT_FUND_10_OWNER: RelationshipToIssuer = 'Investment Fund, 10% Owner';
  export const INVESTMENT_HOLDING_COMPANY: RelationshipToIssuer = 'Investment Holding Company';
  export const FAMILY_OFFICE_5_: RelationshipToIssuer = 'Family Office, 5%';
  export const SPONSOR_ENTITY_: RelationshipToIssuer = 'Sponsor (Entity)';
  export const _10_OWNER: RelationshipToIssuer = '10% Owner';
  export const FAMILY_CONTROLLED_CORPORATION: RelationshipToIssuer = 'family controlled corporation';
  export const DEPOSITARY_BANK: RelationshipToIssuer = 'Depositary Bank';
  export const NOMINATED_ADVISOR: RelationshipToIssuer = 'Nominated Advisor';
  export const LENDING_AGENT: RelationshipToIssuer = 'Lending agent';
  export const EXCHANGE_TRADED_FUND: RelationshipToIssuer = 'Exchange Traded Fund';
  export const BROKER: RelationshipToIssuer = 'Broker';
  export const CUSTODIAN_CORPORATION: RelationshipToIssuer = 'Custodian corporation';
  export const NOMINATED_ADVISOR_AND_BROKER: RelationshipToIssuer = 'Nominated Advisor and Broker';
  export const CUSTODIAN: RelationshipToIssuer = 'Custodian';
  export const NATIONAL_RETIREMENT_SYSTEM: RelationshipToIssuer = 'National Retirement System';
  export const GOVERNMENT_MUNICIPALITY: RelationshipToIssuer = 'Government/Municipality';
  export const GOVERNMENT_STATUTORY_BODY: RelationshipToIssuer = 'Government Statutory Body';
  export const GOVERNMENT_LINKED_COMPANY: RelationshipToIssuer = 'Government-linked company';
  export const POLITICAL_PARTY: RelationshipToIssuer = 'Political Party';
  export const PUBLIC_PENSION_FUND: RelationshipToIssuer = 'Public Pension Fund';
  export const INTERNATIONAL_FINANCE_INSTITUTION: RelationshipToIssuer = 'International Finance Institution';
  export const DEPOSIT_INSURANCE_10_OWNER: RelationshipToIssuer = 'Deposit Insurance, 10% Owner';
  export const INTERNATIONAL_FINANCE_INSTITUTE: RelationshipToIssuer = 'International Finance Institute';
  export const STATE_OWNED_COMPANY: RelationshipToIssuer = 'State-owned company';
  export const GOVERNMENT_SOVEREIGN_FUND_MANAGER: RelationshipToIssuer = 'Government Sovereign Fund Manager';
  export const GOVERNMENT_AGENCY: RelationshipToIssuer = 'Government Agency';
  export const STATE_TEACHERS_RETIREMENT_SYSTEM: RelationshipToIssuer = 'State Teachers Retirement System';
  export const SOVEREIGN_WEALTH_FUND: RelationshipToIssuer = 'Sovereign Wealth Fund';
  export const GOVERNMENT_OWNED_COMPANY: RelationshipToIssuer = 'Government owned company';
  export const NATIONAL_PENSION_PLAN: RelationshipToIssuer = 'National Pension Plan';
  export const PUBLIC_INVESTMENT_FUND: RelationshipToIssuer = 'Public Investment Fund';
  export const PROVINCED_OWNED_ENTITY: RelationshipToIssuer = 'Provinced-Owned Entity';
  export const CENTRAL_BANK: RelationshipToIssuer = 'Central Bank';
  export const SUPRANATIONAL_BANK: RelationshipToIssuer = 'Supranational Bank';
  export const GOVERNMENT_PENSION_FUND_MANAGER: RelationshipToIssuer = 'Government Pension Fund Manager';
  export const PUBLIC_BANK: RelationshipToIssuer = 'Public Bank';
  export const PUBLIC_INVESTMENT_BANK: RelationshipToIssuer = 'Public Investment Bank';
  export const INTERNATIONAL_GOVERNMENTAL_ORGANISATION: RelationshipToIssuer = 'International Governmental Organisation';
  export const MULTILATERAL_DEVELOPMENT_BANK: RelationshipToIssuer = 'Multilateral Development Bank';
  export function values(): RelationshipToIssuer[] {
    return [
      FAMILY_HOLDING,
      FOUNDATION,
      MANAGEMENT_HOLDING,
      SHAREHOLDER,
      ASSET_MANAGEMENT_COMPANY,
      FINANCIAL_SERVICES_COMPANY,
      HEDGE_FUND,
      HOLDING_COMPANY,
      INVESTMENT_COMPANY,
      INVESTMENT_FUND,
      INVESTMENT_MANAGEMENT_COMPANY,
      PRIVATE_EQUITY,
      VENTURE_CAPITAL,
      AFFILIATED_COMPANY,
      ENDOWMENT_FUND,
      PARENT_COMPANY,
      PUBLIC_COMPANY,
      GOVERNMENT_RELATED_ENTITIES,
      LEGAL_ENTITY_REPRESENTATION_ON_BOARD,
      FAMILY_HOLDING_10_,
      FOUNDATION_10_,
      MANAGEMENT_HOLDING_10_,
      SHAREHOLDER_10_,
      ASSET_MANAGEMENT_COMPANY_10_,
      FINANCIAL_SERVICES_COMPANY_10_,
      HEDGE_FUND_10_,
      HOLDING_COMPANY_10_,
      INVESTMENT_COMPANY_10_,
      INVESTMENT_FUND_10_,
      INVESTMENT_MANAGEMENT_COMPANY_10_,
      PRIVATE_EQUITY_10_,
      VENTURE_CAPITAL_10_,
      AFFILIATED_COMPANY_10_,
      ENDOWMENT_FUND_10_,
      PUBLIC_COMPANY_10_,
      FAMILY_HOLDING_REPRESENTATION_ON_BOARD,
      FOUNDATION_REPRESENTATION_ON_BOARD,
      SHAREHOLDER_REPRESENTATION_ON_BOARD,
      ASSET_MANAGEMENT_COMPANY_REPRESENTATION_ON_BOARD,
      FINANCIAL_SERVICES_COMPANY_REPRESENTATION_ON_BOARD,
      HEDGE_FUND_REPRESENTATION_ON_BOARD,
      HOLDING_COMPANY_REPRESENTATION_ON_BOARD,
      INVESTMENT_COMPANY_REPRESENTATION_ON_BOARD,
      INVESTMENT_FUND_REPRESENTATION_ON_BOARD,
      INVESTMENT_MANAGEMENT_COMPANY_REPRESENTATION_ON_BOARD,
      PRIVATE_EQUITY_REPRESENTATION_ON_BOARD,
      VENTURE_CAPITAL_REPRESENTATION_ON_BOARD,
      ENDOWMENT_FUND_REPRESENTATION_ON_BOARD,
      PUBLIC_COMPANY_REPRESENTATION_ON_BOARD,
      GOVERNMENT_RELATED_ENTITIES_REPRESENTATION_ON_BOARD,
      BOARD_OF_DIRECTORS_HOLDINGS,
      FAMILY_HOLDING_A_,
      MANAGEMENT_BOARD,
      FUND_MANAGER_A_,
      INVESTMENT_MANAGER_A_LEVEL_,
      FAMILY_OFFICE_A_,
      MANAGEMENT_HOLDING_B_,
      AUDIT_COMMITTEE_AS_GROUP_,
      FAMILY_HOLDING_B_,
      INVESTMENT_ADVISORY_COMPANY_BO_D,
      INVESTMENT_BANK_REPRESENTED_IN_THE_BOARD,
      INVESTMENT_HOLDING_COMPANY_BO_D,
      INVESTMENT_BOUTIQUE_REPRESENTED_IN_THE_BOARD,
      INVESTMENT_FUND_10_OWNER_BO_D,
      FAMILY_OWNED_COMPANY_C_,
      INVESTMENT_COMPANY_REPRESENTED_IN_THE_BOARD,
      BOARD_OF_COMMISSIONERS,
      PRIVATE_EQUITY_COMPANY_REPRESENTED_IN_THE_BOARD,
      COOPERATIVE_OR_ASSOCIATION_BO_D_10_OWNER,
      BOARD_OF_AUDITORS,
      HEDGE_FUND_COMPANY_REPRESENTED_IN_THE_BOARD,
      BANK_REPRESENTED_IN_THE_BOARD,
      INVESTMENT_FUND_REPRESENTED_IN_THE_BOARD,
      PRIVATE_EQUITY_10_OWNER_REPRESENTED_IN_THE_BOARD,
      REIT_5_OWNER_BO_D,
      VENTURE_CAPITAL_COMPANY_10_OWNER_BO_D,
      PRIVATE_EQUITY_FUND_BO_D,
      INSURANCE_COMPANY_10_OWNER_BO_D,
      HOLDING_COMPANY_REPRESENTED_IN_THE_BOARD,
      REIT_10_OWNER_BO_D,
      BOARD_OF_DIRECTORS_HOLDING,
      VENTURE_CAPITAL_COMPANY_REPRESENTED_IN_THE_BOARD,
      BANK_10_OWNER_BO_D,
      INVESTMENT_FUND_5_OWNER_BO_D,
      PRIVATE_EQUITY_COMPANY_10_OWNER_BO_D,
      FOUNDATION_REPRESENTED_IN_THE_BOARD,
      HEDGE_FUND_10_OWNER_BO_D,
      INSURANCE_COMPANY_5_OWNER_BO_D,
      PRIVATE_EQUITY_FUND_5_OWNER_BO_D,
      FAMILY_OFFICE_C_,
      FAMILY_HOLDING_C_,
      SHAREHOLDERS_COMMITTEE,
      CONNECTED_ENTITY,
      INVESTMENT_MANAGEMENT_COMPANY_10_OWNER_BO_D,
      FINANCIAL_SERVICE_COMPANY_BO_D,
      ALTERNATIVE_INVESTMENT_FIRM_REPRESENTED_IN_THE_BOARD,
      PRIVATE_EQUITY_REPRESENTED_IN_THE_BOARD,
      VENTURE_CAPITAL_FUND_REPRESENTED_IN_THE_BOARD,
      INVESTMENT_COMPANY_10_OWNER_BO_D,
      INVESTMENT_MANAGEMENT_COMPANY_BO_D,
      REIT,
      HOLDING_COMPANY_10_OWNER_BO_D,
      REIT_3_OWNER,
      ASSET_MANAGEMENT_COMPANY_10_OWNER_BO_D,
      VENTURE_CAPITAL_COMPANY_5_OWNER_BO_D,
      LEGAL_ENTITY_REPRESENTED_IN_THE_BOARD,
      PRIVATE_EQUITY_FUND_10_OWNER_BO_D,
      ALTERNATIVE_INVESTMENT_FIRM_REPRESENTED_IN_THE_BOARD_10_OWNER,
      REAL_ESTATE_HOLDING_COMPANY_10_OWNER_BO_D,
      REIT_5_OWNER,
      INVESTMENT_BANK_10_OWNER_BO_D,
      HEDGE_FUND_REPRESENTED_IN_THE_BOARD,
      REAL_ESTATE_HOLDING_COMPANY_BO_D,
      ASSET_MANAGEMENT_COMPANY_REPRESENTED_IN_THE_BOARD,
      REIT_10_OWNER,
      INSURANCE_COMPANY_REPRESENTED_IN_THE_BOARD,
      GRANTOR_RETAINED_ANNUITY_TRUST,
      INFLUENCED_CORPORATION,
      OTHER_AS_GROUP_,
      UNDERWRITER,
      TRADE_UNION,
      BANK,
      RELATED_PARTY,
      EMPLOYEE_TRUST,
      REIT_MANAGEMENT_COMPANY,
      COMPANY_GENERAL_PARTNER,
      DISCRETIONARY_TRUST,
      FUND,
      FUND_ADVISORY_COMPANY,
      NONPROFIT_ORGANIZATION,
      CLOSED_END_FUND_5_,
      COMPANY_INVESTMENT_MANAGER,
      LEGAL_ENTITY,
      FAMILY,
      ASSOCIATED_COMPANY,
      CHARITABLE_TRUST,
      CHARITABLE_FOUNDATION,
      PHILANTHROPIC_FOUNDATION,
      INVESTMENT_TRUST,
      FAMILY_OFFICE_TRUST,
      MARKET_MAKER,
      SUBSIDIARY,
      COMPANY_ASSET_MANAGER,
      CLOSED_END_FUND,
      ACCOUNT,
      INVESTMENT_BANK_10_OWNER,
      PRIVATE_EQUITY_COMPANY_5_OWNER,
      FINANCIAL_SERVICES_COMPANY_5_OWNER,
      REAL_ESTATE_INVESTMENT_HOLDING_COMPANY_10_OWNER,
      REAL_ESTATE_INVESTMENT_HOLDING_COMPANY_5_OWNER,
      PROPRIETARY_TRADING_FIRM,
      PRIVATE_EQUITY_5_OWNER,
      WEALTH_MANAGEMENT_COMPANY,
      PRIVATE_EQUITY_COMPANY_10_OWNER,
      _10_HOLDER,
      INVESTOR_5_OWNER,
      ACTIVIST_INVESTOR_3_OWNER,
      ASSET_MANAGEMENT_COMPANY_10_OWNER,
      BANK_10_OWNER,
      SPECIAL_PURPOSE_ENTITY,
      _3_SHAREHOLDER,
      VENTURE_CAPITAL_COMPANY_10_OWNER,
      CONTROLLING_SHAREHOLDER,
      HEDGE_FUND_3_OWNER,
      INVESTMENT_FIRM_5_OWNER,
      VENTURE_CAPITAL_COMPANY_5_OWNER,
      INVESTMENT_TRUST_10_OWNER,
      _5_SHAREHOLDER,
      FAMILY_HOLDING_10_OWNER,
      INVESTMENT_BOUTIQUE,
      PRIVATE_EQUITY_COMPANY,
      INVESTMENT_FUND_3_OWNER,
      INVESTMENT_MANAGEMENT_COMPANY_5_OWNER,
      PUBLIC_COMPANY_5_OWNER,
      VENTURE_CAPITAL_FUND_10_OWNER,
      JOINT_OWNERSHIP,
      INVESTMENT_BANK,
      PHILANTHROPIC_FOUNDATION_10_OWNER,
      VENTURE_CAPITAL_COMPANY,
      IRREVOCABLE_TRUST_10_OWNER,
      INVESTMENT_COMPANY_10_OWNER,
      PRIVATE_COMPANY,
      ALTERNATIVE_INVESTMENT_FIRM_10_OWNER,
      FOUNDATION_10_OWNER,
      FAMILY_OFFICE,
      PARTNER,
      PENSION_TRUSTEE,
      INVESTMENT_ADVISORY_COMPANY_3_,
      HEDGE_FUND_10_OWNER,
      ALTERNATIVE_INVESTMENT_FIRM,
      INVESTOR_3_OWNER,
      INVESTMENT_MANAGEMENT_COMPANY_10_OWNER,
      SHAREHOLDER_ACTING_IN_CONCERT_,
      INVESTMENT_ADVISORY_COMPANY_10_,
      HOLDING_COMPANY_10_OWNER,
      INVESTMENT_FUND_5_OWNER,
      MARITAL_TRUST_10_OWNER,
      INSURANCE_COMPANY_3_OWNER,
      PROMOTER_GROUP_PAC_,
      MARITAL_TRUST,
      ACTIVIST_INVESTOR,
      FINANCIAL_SERVICES_COMPANY_10_OWNER,
      PUBLIC_COMPANY_10_OWNER,
      INVESTMENT_TRUST_5_OWNER,
      REVOCABLE_TRUST_10_OWNER,
      INVESTMENT_FIRM_3_OWNER,
      MEMBER_OF_A_CONTROLLING_GROUP,
      INVESTMENT_BOUTIQUE_5_OWNER,
      _13D_GROUP,
      INVESTMENT_TRUST_3_OWNER,
      INVESTMENT_BOUTIQUE_3_OWNER,
      IRREVOCABLE_TRUST,
      INVESTMENT_HOLDING_COMPANY_5_OWNER,
      ASSET_MANAGEMENT_COMPANY_5_OWNER,
      VENTURE_CAPITAL_FUND_3_OWNER,
      BANK_5_OWNER,
      PRIVATE_COMPANY_10_OWNER,
      PENSION_FUND_5_OWNER,
      LIVING_TRUST,
      ENDOWMENT_FUND_10_OWNER,
      LIVING_TRUST_10_OWNER,
      INVESTMENT_COMPANY_3_OWNER,
      INSURANCE_COMPANY_5_OWNER,
      INSURANCE_COMPANY_10_OWNER,
      REAL_ESTATE_INVESTMENT_COMPANY_10_OWNER,
      VENTURE_CAPITAL_FUND,
      SPECIAL_PURPOSE_ENTITY_5_,
      INVESTOR,
      INVESTMENT_BANK_5_OWNER,
      FAMILY_OFFICE_10_,
      WEALTH_MANAGEMENT_COMPANY_10_OWNER,
      CONTROLLING_GROUP,
      _10_OWNER_GROUP,
      ACTIVIST_INVESTOR_REPRESENTED_IN_THE_BO_D,
      ESTATE,
      LIMITED_PARTNERSHIP,
      WEALTH_MANAGEMENT_COMPANY_5_OWNER,
      REAL_ESTATE_HOLDING_COMPANY,
      GENERAL_PARTNER,
      REAL_ESTATE_HOLDING_COMPANY_5_OWNER,
      INVESTMENT_MANAGEMENT_COMPANY_3_OWNER,
      REAL_ESTATE_HOLDING_COMPANY_10_OWNER,
      ACTIVIST_INVESTOR_5_OWNER,
      DECEASED_D_,
      PRIVATE_EQUITY_COMPANY_MAIN_SHAREHOLDER,
      INVESTMENT_ADVISORY_COMPANY,
      INVESTMENT_COMPANY_5_OWNER,
      INDIRECT_SHAREHOLDER,
      HEDGE_FUND_COMPANY_10_OWNER,
      FAMILY_HOLDING_3_OWNER,
      REAL_ESTATE_INVESTMENT_HOLDING_COMPANY,
      PRIVATE_EQUITY_FUND,
      INSURANCE_COMPANY,
      AFFILIATED_PERSON,
      ENDOWMENT_FUND_5_,
      _10_SHAREHOLDER,
      INVESTMENT_FIRM,
      INVESTMENT_BOUTIQUE_10_OWNER,
      ACTIVIST_INVESTOR_10_OWNER,
      NOMINEE_ACCOUNT_UNKNOWN_,
      REVOCABLE_TRUST,
      PENSION_FUND,
      PRIVATE_EQUITY_10_OWNER,
      INVESTMENT_HOLDING_COMPANY_10_OWNER,
      HEDGE_FUND_5_OWNER,
      INVESTOR_10_OWNER,
      MANAGING_PARTNER_H_,
      MAJORITY_SHAREHOLDER_ACTING_IN_CONCERT_,
      INVESTMENT_HOLDING_COMPANY_3_OWNER,
      FORMER_INSIDER_LARGE_SHAREHOLDER,
      MAIN_SHAREHOLDER,
      ASSET_MANAGEMENT_COMPANY_3_OWNER,
      PRIVATE_COMPANY_5_OWNER,
      PENSION_FUND_10_OWNER,
      PRIVATE_EQUITY_FUND_5_OWNER,
      SPECIAL_PURPOSE_ENTITY_10_,
      VENTURE_CAPITAL_COMPANY_3_OWNER,
      PRIVATE_EQUITY_FUND_10_OWNER,
      SUBSTANTIAL_SHAREHOLDER,
      VENTURE_CAPITAL_FUND_5_OWNER,
      MAJORITY_SHAREHOLDER,
      HOLDING_COMPANY_5_OWNER,
      INVESTMENT_ADVISORY_COMPANY_5_,
      ALTERNATIVE_INVESTMENT_FIRM_5_OWNER,
      FAMILY_HOLDING_5_OWNER,
      INVESTMENT_FIRM_10_OWNER,
      INVESTMENT_FUND_10_OWNER,
      INVESTMENT_HOLDING_COMPANY,
      FAMILY_OFFICE_5_,
      SPONSOR_ENTITY_,
      _10_OWNER,
      FAMILY_CONTROLLED_CORPORATION,
      DEPOSITARY_BANK,
      NOMINATED_ADVISOR,
      LENDING_AGENT,
      EXCHANGE_TRADED_FUND,
      BROKER,
      CUSTODIAN_CORPORATION,
      NOMINATED_ADVISOR_AND_BROKER,
      CUSTODIAN,
      NATIONAL_RETIREMENT_SYSTEM,
      GOVERNMENT_MUNICIPALITY,
      GOVERNMENT_STATUTORY_BODY,
      GOVERNMENT_LINKED_COMPANY,
      POLITICAL_PARTY,
      PUBLIC_PENSION_FUND,
      INTERNATIONAL_FINANCE_INSTITUTION,
      DEPOSIT_INSURANCE_10_OWNER,
      INTERNATIONAL_FINANCE_INSTITUTE,
      STATE_OWNED_COMPANY,
      GOVERNMENT_SOVEREIGN_FUND_MANAGER,
      GOVERNMENT_AGENCY,
      STATE_TEACHERS_RETIREMENT_SYSTEM,
      SOVEREIGN_WEALTH_FUND,
      GOVERNMENT_OWNED_COMPANY,
      NATIONAL_PENSION_PLAN,
      PUBLIC_INVESTMENT_FUND,
      PROVINCED_OWNED_ENTITY,
      CENTRAL_BANK,
      SUPRANATIONAL_BANK,
      GOVERNMENT_PENSION_FUND_MANAGER,
      PUBLIC_BANK,
      PUBLIC_INVESTMENT_BANK,
      INTERNATIONAL_GOVERNMENTAL_ORGANISATION,
      MULTILATERAL_DEVELOPMENT_BANK
    ];
  }
}

export { RelationshipToIssuer }